'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reduxImmutable = require('redux-immutable');

var _connectionsReducer = require('./connectionsReducer');

var _connectionsReducer2 = _interopRequireDefault(_connectionsReducer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Lib
exports.default = (0, _reduxImmutable.combineReducers)({
    connections: _connectionsReducer2.default
});

// Reducers


//////////////////
// WEBPACK FOOTER
// ./src/client/components/connections/reducers/rootElementConnectionsReducer.js
// module id = 1713
// module chunks = 0